import ContentNotFetchedPlaceholder from './content-not-fetched.svg';
import FacebookReviewPlaceholder from './facebook-review.svg';
import GoogleReviewPlaceholder from './google-review.svg';

const LegacyReviewPage =
  'https://storage.googleapis.com/wsf-prod-1-messaging-media-public/96bb3af1-75bb-441d-ae03-73f010aa7fdf/STATIC_ASSETS/6081f71a-cbe4-43aa-b740-9956b816db6b_legacy-review.png';

export { ContentNotFetchedPlaceholder, GoogleReviewPlaceholder, FacebookReviewPlaceholder, LegacyReviewPage };
